import {useMutation} from "@tanstack/react-query";
import {moveCustomerOfferToDraftMutationOptions} from "./move-customer-offer-to-draft.mutation-options";

export function useMoveCustomerOfferToDraft() {
  return useMutation(moveCustomerOfferToDraftMutationOptions());
}
